import React, { useState } from 'react';
import SelectBox from 'src/components/SelectBox/SelectBox';

import AiCommonModal from './AiCommonModal';

const EQUIPMENT_TYPE_OPTIONS = [
    { label: 'Dry Van', value: 'dry_van' },
    { label: 'Reefer', value: 'reefer' },
    { label: 'Flatbed', value: 'flatbed' },
    { label: 'Step Deck', value: 'step_deck' },
];

interface IProps {
    step: number;
    totalSteps: number;
    onSubmit: (equipmentType: string) => void;
    onBack: () => void;
    onClose: () => void;
}

const EquipmentTypeCard = ({ step, totalSteps, onSubmit, onBack, onClose }: IProps) => {
    const [equipmentType, setEquipmentType] = useState(EQUIPMENT_TYPE_OPTIONS[0].value);

    return (
        <AiCommonModal
            title={
                <div className="flex items-center justify-between w-full">
                    <span>Select equipment type</span>
                    <span className="text-gray400 text-xs font-normal">
                        {step}/{totalSteps}
                    </span>
                </div>
            }
            agent="kate"
            handleClose={onClose}
            secondaryBtnText="Back"
            secondaryBtnOnClick={onBack}
            primaryBtnText="Submit"
            primaryBtnOnClick={() => onSubmit(equipmentType)}
        >
            <p className="text-gray500 text-xs leading-[1.5] font-normal mb-3">Do you have a preferred equipment type, or should I use a Dry Van?</p>
            <SelectBox
                name="equipmentType"
                id="equipmentType"
                options={EQUIPMENT_TYPE_OPTIONS}
                value={EQUIPMENT_TYPE_OPTIONS.find((o) => o.value === equipmentType)}
                onChangeFunc={(opt: any) => setEquipmentType(opt?.value ?? EQUIPMENT_TYPE_OPTIONS[0].value)}
                isSearchable={false}
            />
        </AiCommonModal>
    );
};

export default EquipmentTypeCard;
